import Dropdown from "components/atoms/Dropdown/Dropdown";
import { capitalizeFirstLetter } from "helpers/commonHelpers";
import { FormattedMessage } from "react-intl";

function HandlingUnitField({ options }: any) {
  return (
    <div className="w-90-px">
      <label className="label">
        <FormattedMessage id="new-request.packing-list.handlingUnit" defaultMessage="Handling unit" />
      </label>
      <Dropdown
        useHookForm
        name="handling_unit"
        defaultValue={options[0].label || ""}
        options={options.map((option: any) => ({
          label: capitalizeFirstLetter(option.label),
          value: option.label,
        }))}
      />
    </div>
  );
}

export default HandlingUnitField;
